<template>
    <notification-standard class="notification-behavioral" :item="item" @notification:targeted="triggerTarget" @notification:deleted="triggerDelete">
        <template slot="title"><slot name="title"></slot></template>

        <slot name="">
            <div class="notification-body" style="" v-if="item.targeted">
                <slot name="body"></slot>

                <div class="notification-behavior-container"  v-if="behaviorShown">
                    <div v-html="behaviorContent" ref="behaviorContainer" v-if="hasBehaviors"></div>
                    <slot name="behaviors"></slot>
                </div>
            </div>

            <div class="notification-footer" v-if="item.targeted">
                <slot name="footer">
                    <div class="behaviors-container" style="display:flex;overflow:hidden">
                        <div v-for="b in behaviors" class="behavior text-center" style="flex: 1 1 auto;">
                            <span class="behavior-btn btn" :class="getBehaviorButtonClass(b.name)" :title="b.title" @click="loadBehavior(b)">
                                <span class="glyphicon" :class="b.icon"></span>
                                {{b.label}}
                            </span>
                        </div>
                    </div>
                </slot>
            </div>
        </slot>
    </notification-standard>
</template>

<script>
    import axios from '@/api/client'
    import NotificationStandard from '@/components/notifications/behaviors/Standard'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            behaviors: {
                type: Array,
                required: true
            }
        },
        name: 'NotificationBehavioral',
        data () {
            return {
                loadedBehavior: '',
                behaviorContent: ''
            }
        },
        computed: {
            hasBehaviors: function () {
                return this.behaviors.length > 0
            },
            behaviorShown: function () {
                return this.loadedBehavior.length > 0
            }
        },
        methods: {
            triggerTarget: function () {
                if (this.$parent) {
                    this.$parent.$emit('notification:targeted', this.item)
                } else {
                    this.$emit('notification:targeted', this.item)
                }
            },
            triggerDelete: function (e) {
                if (this.$parent) {
                    this.$parent.$emit('notification:deleted', this.item)
                } else {
                    this.$emit('notification:deleted', this.item)
                }
            },
            loadBehavior: function (notification) {
                try {
                    if (this.loadedBehavior === notification.name) {
                        this.loadedBehavior = ''
                        return
                    }

                    this.loadedBehavior = notification.name
                    this.showBehaviorMessage('Loading...')

                    if (typeof notification.requestAction !== 'undefined') {
                        this.loadRemoteBehavior(notification)
//                    } else if (typeof notification.component !== 'undefined') {
//                        this.behaviorContent = ''
                    } else {
                        throw new Error('Unable to load behavior: ' + notification.name)
                    }
                } catch (err) {
                    this.showBehaviorMessage(err.message, 'danger')
                }
            },
            loadRemoteBehavior: async function (notification) {
                if (typeof notification.requestMethod === 'undefined') {
                    notification.requestMethod = 'get'
                }

                const resp = await axios[notification.requestMethod](notification.requestAction())

                if (resp.data.html) {
                    this.behaviorContent = resp.data.html
                } else if (resp.data.data && typeof resp.data.data === 'string') {
                    this.behaviorContent = resp.data.data
                }

                this.processResponse(resp)

                if (resp.data.message) {
                    this.showBehaviorMessage(resp.data.message, 'danger')
                }
            },
            showBehaviorMessage: function (message, level) {
                let assembledMessage = message

                if (typeof level !== 'undefined') {
                    assembledMessage = '<div class="text-center well-sm bg-' + level + '">' + message + '</div>'
                }

                this.behaviorContent = assembledMessage
            },
            getBehaviorButtonClass: function (behavior) {
                return this.loadedBehavior === behavior ? 'btn-default' : 'btn-primary'
            },
            processResponse: function (resp) {
                this.$nextTick(() => {
                    if (this.$refs.behaviorContainer) {
                        if (resp.data.links) {
                            resp.data.links.forEach(i => {
                                const link = document.createElement('link')
                                link.setAttribute('type', 'text/css')
                                link.setAttribute('rel', 'stylesheet')
                                link.setAttribute('media', 'screen')
                                link.setAttribute('href', i)
                                this.$refs.behaviorContainer.appendChild(link)
                            })
                        }

                        if (resp.data.scripts) {
                            resp.data.scripts.forEach(i => {
                                const script = document.createElement('script')
                                script.setAttribute('type', 'text/javascript')
                                script.setAttribute('src', i)

                                this.$refs.behaviorContainer.appendChild(script)
                            })
                        }

                        // Block any post backs
                        // can't use forEach due to PhantomJS not supporting it on NodeList
                        const forms = this.$refs.behaviorContainer.querySelectorAll('form')
                        for (let ctr = 0; ctr < forms.length; ctr++) {
                            forms[ctr].addEventListener('submit', this.interceptForm, true)
                        }
//                    this.$refs.behaviorContainer.querySelectorAll('form').forEach(i => {
//                        i.addEventListener('submit', this.interceptForm, true)
//                    })

                        this.$emit('behaviorLoaded:' + this.loadedBehavior, this.$refs.behaviorContainer)
                    }
                })
            },
            interceptForm: async function (e) {
                try {
                    e.preventDefault()
                    e.stopImmediatePropagation()

                    const method = e.target.hasAttribute('method') ? e.target.getAttribute('method') : 'get'
                    const url = e.target.hasAttribute('action') ? e.target.getAttribute('action') : window.location.href
                    const formData = new FormData(e.target)

                    const resp = await axios[method](url, formData)

                    if (resp.data) {
                        if (resp.data.result) {
                            this.$emit('behaviorCompleted:' + this.loadedBehavior, resp.data, this.$refs.behaviorContainer)
                        } else {
                            this.showBehaviorMessage(resp.data.message, 'danger')
                        }
                    } else {
                        this.showBehaviorMessage('Invalid response', 'danger')
                    }
                } catch (err) {
                    this.showBehaviorMessage(err.message, 'danger')
                }
            },
            downloadAjaxFile: function (name, contents, container) {
                // @ToDo Need to switch this to a LocalStorage download library so that large files get handled automatically
                const link = document.createElement('a')
                link.setAttribute('href', contents)
                link.setAttribute('download', name)
                link.setAttribute('style', 'display:none')

                const node = container.appendChild(link)
                node.click()
                container.removeChild(node)
            }
        },
        components: {
            NotificationStandard
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Behavioral.vue?5e153602